import { componentStyleWithExtend } from '@/styling/util/component-style.ts';
import type { CardDesignTokens } from '@primeuix/themes/types/card';

export const cardStyle: ReturnType<typeof componentStyleWithExtend<CardDesignTokens>> =
    componentStyleWithExtend<CardDesignTokens>({
        extend: {
            root: {
                border: '1px solid {content.border.color}',
            },
        },
        style: {
            root: {
                shadow: '0',
                borderRadius: '{border.radius.sm}',
            },
            body: {
                padding: '1rem',
            },
        },
        css: ({ dt }) => `
        .p-component.p-card {
            border: ${String(dt('card.border'))};
        }
        
        .p-card-title {
            margin-bottom: .5rem;
        }
    `,
    });
